/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClaimCollateralType = {
    BuildingSavingsContract: 'BuildingSavingsContract',
    LifeInsurance: 'LifeInsurance',
    PensionInsurance: 'PensionInsurance',
    SavingsAccount: 'SavingsAccount',
    Securities: 'Securities',
    RealEstate: 'RealEstate',
    WagePledge: 'WagePledge',
    Other: 'Other'
} as const;
export type ClaimCollateralType = typeof ClaimCollateralType[keyof typeof ClaimCollateralType];


export function instanceOfClaimCollateralType(value: any): boolean {
    for (const key in ClaimCollateralType) {
        if (Object.prototype.hasOwnProperty.call(ClaimCollateralType, key)) {
            if (ClaimCollateralType[key as keyof typeof ClaimCollateralType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClaimCollateralTypeFromJSON(json: any): ClaimCollateralType {
    return ClaimCollateralTypeFromJSONTyped(json, false);
}

export function ClaimCollateralTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCollateralType {
    return json as ClaimCollateralType;
}

export function ClaimCollateralTypeToJSON(value?: ClaimCollateralType | null): any {
    return value as any;
}

export function ClaimCollateralTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ClaimCollateralType {
    return value as ClaimCollateralType;
}

